// this constant is read-only
export const RoomType = {
  RED: 'RED',
  GRAY: 'GRAY',
  YELLOW: 'YELLOW',
};
